import hx from "../utils/hydroxie";
import { ContentControl } from "../utils/maputil/legendcontrol";

/**
 * 地図上でCtrlキーを押しながらドラッグして検索範囲を選択できることを示すメッセージコントロール。
 */
export class DragMessageControl extends ContentControl {
    /**
     * コンストラクター。
     */
    constructor() {
        const content = hx("div", { className: "ol-drag-message-control-content" },
            "Ctrlキーを押しながらドラッグすることで検索対象エリアを選択できます。");
        const style = {
            "font-size": "small",
            top: "0.5rem",
            left: "2.5rem",
        };

        super({ content, style });
    }
}
